var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiceRed6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-678 -265) translate(48 265) translate(630)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#FF4664",
    fillOpacity: 0.3,
    rx: 28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 57,
    fill: "#FF4664",
    stroke: "#FF7C91"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 79.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 60.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 60.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 79.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 40.5,
    r: 8.5,
    fill: "#FFF"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceRed6);
export default __webpack_public_path__ + "static/media/dice-red-6.3ee98ff0915e6c2e2fc9a18ae0370889.svg";
export { ForwardRef as ReactComponent };